/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
// import constantName from "./key"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_sales`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Create sales details

export async function createSalesRecord(salesListData) {
  console.log("inside api call------------", salesListData)
  try {
    const response = await api.post(`/add_sales`, salesListData)
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//Update sales details
export async function updateSalesRecord(salesListData) {
  console.log("inside api call------------", salesListData)
  try {
    const response = await api.put(`/update_sales`, salesListData)
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

// Get sales temp List

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesTempDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_sales_temp`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Create sales Temp details

export async function createSalesTempRecord(payments) {
  console.log("inside api call------------", payments)
  try {
    const response = await api.post(`/add_sales_temp`, payments)
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//Update sales Temp details
export async function updateSalesTempRecord(payments) {
  console.log("inside api call------------", payments)
  try {
    const response = await api.put(`/update_sales_temp_by_id`, payments)
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//Delete sales Temp details
/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteSalesTempRecord(salesTempId) {
  const payload = { salesTempId: salesTempId }
  return api
    .put(`/delete_sales_temp_by_id`, payload)
    .catch((error) => Promise.reject(error))
}

//Update event details

export async function updateEventRecord(eventData) {
  console.log("inside api call------------", eventData)
  try {
    const response = await api.put(
      `/update_approved_lead_event_by_id`,
      eventData
    )
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//bank details

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadBankDetailsList(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_bank_account`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//sales approval

/**
 *
 * @param {integer} id
 * @returns
 */
export function approvalSalesRequestQc(id, leadQuotationId, salesId, remarks) {
  const payload = {
    leadId: id,
    leadQuotationId: leadQuotationId,
    salesId: salesId,
    remarks: remarks,
  }
  return api
    .post(`/sales_edit_request_approval`, payload)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function updateSalesReapproveQc(qcUpdateData) {
  return api
    .put(`/update_sales_qc_approval`, qcUpdateData)
    .catch((error) => Promise.reject(error))
}
/**
 *
 * @param {integer} id
 * @returns
 */
export function bookingCompleteDetails(bookingComplete) {
  return api
    .put(`/update_booking_completed_by_id`, bookingComplete)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesPendingDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_sales_pending_qc`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//Qc history
export function loadSalesQcHistoryDetails(salesId) {
  let payload = { status: "active", salesId: salesId }

  return api
    .post(`/get_all_qc_history_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadSalesDetails,
  createSalesRecord,
  updateSalesRecord,
  loadBankDetailsList,
  approvalSalesRequestQc,
  updateSalesReapproveQc,
  loadSalesPendingDetails,
  loadSalesQcHistoryDetails,
  bookingCompleteDetails
}

export default remotes
